import { render, staticRenderFns } from "./dialog-template.vue?vue&type=template&id=6b1b1ac0&scoped=true&"
import script from "./dialog-template.vue?vue&type=script&lang=js&"
export * from "./dialog-template.vue?vue&type=script&lang=js&"
import style0 from "./dialog-template.vue?vue&type=style&index=0&id=6b1b1ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b1ac0",
  null
  
)

export default component.exports